module.exports = __webpack_public_path__ + "media/images/icons/SVG/052-fade0c7040a5928e58a953f04e1a6c63.svg";